module.exports = __webpack_public_path__ + "img/icon-calendar.44b5568a.svg";